export default [
  {
    label: 'Intro',
    page: '/',
  },
  {
    label: 'Purpose',
    page: '/slides',
    slide: 1, // location of the slide within the slides structure
  },
  {
    label: 'Values',
    page: '/slides',
    slide: 5, // location of the slide within the slides structure
    subLabel1: 'Our Values', //Label of sub-slide
    subSlide1: 8, //location of the sub-slide within the slides structure
    subLabel2: 'Greatness', //Label of sub-slide
    subSlide2: 10, //location of the sub-slide within the slides structure
    subLabel3: 'Delight', //Label of sub-slide
    subSlide3: 12, //location of the sub-slide within the slides structure
    subLabel4: 'Ownership', //Label of sub-slide
    subSlide4: 14, //location of the sub-slide within the slides structure
    subLabel5: 'Dialogue', //Label of sub-slide
    subSlide5: 16, //location of the sub-slide within the slides structure
    subLabel6: 'Action', //Label of sub-slide
    subSlide6: 18, //location of the sub-slide within the slides structure
  }, {
    label: 'People',
    page: '/slides',
    slide: 19, // location of the slide within the slides structure
    subLabel1: 'Our People', //Label of sub-slide
    subSlide1: 21, //location of the sub-slide within the slides structure
    subLabel2: 'Make Others Better', //Label of sub-slide
    subSlide2: 22, //location of the sub-slide within the slides structure
    subLabel3: 'See and Act on Inflections', //Label of sub-slide
    subSlide3: 23, //location of the sub-slide within the slides structure
    subLabel4: 'Intrinsically Motivated & Want to Win', //Label of sub-slide
    subSlide4: 24, //location of the sub-slide within the slides structure
    subLabel5: 'Capable of Winning', //Label of sub-slide
    subSlide5: 25, //location of the sub-slide within the slides structure
    subLabel6: 'Curious & Tenacious', //Label of sub-slide
    subSlide6: 26, //location of the sub-slide within the slides structure
    subLabel7: 'Good', //Label of sub-slide
    subSlide7: 27, //location of the sub-slide within the slides structure
  },
  {
    label: 'Practices',
    page: '/slides',
    slide: 28, // location of the slide within the slides structure
    subLabel1: 'Our Practices', //Label of sub-slide
    subSlide1: 30, //location of the sub-slide within the slides structure
    subLabel2: 'Set Clear Expectations & Context', //Label of sub-slide
    subSlide2: 31, //location of the sub-slide within the slides structure
    subLabel3: 'Autonomy', //Label of sub-slide
    subSlide3: 32, //location of the sub-slide within the slides structure
    subLabel4: 'Personal Development & Self Improvement', //Label of sub-slide
    subSlide4: 33, //location of the sub-slide within the slides structure
  },
  {
    label: 'Tools',
    page: '/slides',
    slide: 34, // location of the slide within the slides structure
  },
  {
    label: 'Behaviors',
    page: '/slides',
    slide: 56, // location of the slide within the slides structure
  },
  {
    label: 'Policies',
    page: '/slides',
    slide: 65, // location of the slide within the slides structure
  },
];